/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StaleFileReference } from './StaleFileReference';
import {
    StaleFileReferenceFromJSON,
    StaleFileReferenceFromJSONTyped,
    StaleFileReferenceToJSON,
} from './StaleFileReference';

/**
 * 
 * @export
 * @interface StaleEntryReferences
 */
export interface StaleEntryReferences {
    /**
     * 
     * @type {string}
     * @memberof StaleEntryReferences
     */
    entryId?: string;
    /**
     * 
     * @type {Array<StaleFileReference>}
     * @memberof StaleEntryReferences
     */
    staleFileReferences?: Array<StaleFileReference>;
}

/**
 * Check if a given object implements the StaleEntryReferences interface.
 */
export function instanceOfStaleEntryReferences(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StaleEntryReferencesFromJSON(json: any): StaleEntryReferences {
    return StaleEntryReferencesFromJSONTyped(json, false);
}

export function StaleEntryReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaleEntryReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryId': !exists(json, 'entryId') ? undefined : json['entryId'],
        'staleFileReferences': !exists(json, 'staleFileReferences') ? undefined : ((json['staleFileReferences'] as Array<any>).map(StaleFileReferenceFromJSON)),
    };
}

export function StaleEntryReferencesToJSON(value?: StaleEntryReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryId': value.entryId,
        'staleFileReferences': value.staleFileReferences === undefined ? undefined : ((value.staleFileReferences as Array<any>).map(StaleFileReferenceToJSON)),
    };
}

